  export const convertToMetric = (unit = "imperial", weight, heightFeet, heightInches) => {
    if (unit === "imperial") {
      const weightInKg = weight * 0.453592; // Convert pounds to kilograms
      const totalHeightInInches =
        parseInt(heightFeet) * 12 + parseInt(heightInches);
      const heightInMeters = totalHeightInInches * 0.0254; // Convert inches to meters
      return { weight: weightInKg, height: heightInMeters };
    }
    return { weight, height: heightFeet / 100 }; // heightFeet contains the height in cm for metric
  };